/**
 * 设备卡片组件
 */
import React from 'react';
import './DeviceCard.css';

const DEVICE_ICONS = {
  phone: '📱',
  laptop: '💻',
  tablet: '📱',
  desktop: '🖥️',
  default: '📡'
};

const DeviceCard = ({ device, onClick }) => {
  const icon = DEVICE_ICONS[device.deviceType] || DEVICE_ICONS.default;
  const isOnline = device.status === 'online';

  const formatDuration = (seconds) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    return `${h}h ${m}m`;
  };

  return (
    <div className="device-card" onClick={onClick}>
      <div className="device-icon">
        {icon}
        <span className={`device-status ${isOnline ? 'online' : 'offline'}`}></span>
      </div>
      
      <div className="device-content">
        <div className="device-name">{device.model_name || device.hostname}</div>
        <div className="device-vendor">{device.vendor || 'Unknown Vendor'}</div>
        <div className="device-tags">
          <span className="device-tag">{device.mac}</span>
          {device.ip && <span className="device-tag">{device.ip}</span>}
        </div>
        {device.todayDuration > 0 && (
          <div className="device-footer">
            <span>⏱️ 今日 {formatDuration(device.todayDuration)}</span>
            {device.appCount > 0 && <span>📱 {device.appCount} 个应用</span>}
          </div>
        )}
      </div>

      <div className="device-arrow">→</div>
    </div>
  );
};

export default DeviceCard;
